import { useContext, useEffect, useState } from 'react';
import { Button, Col, DatePicker, Form, Input, Row, Select, Table } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import { SocketContext } from '../../../App';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

//组件 IngredientWarning 
export default function IngredientWarning(props: any) {

    const [form] = Form.useForm();

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    const notificationApi = useNotificationInstance();

    /** 数据刷新中 */
    let loadings = false;

    /** 预警状态 */
    // const [warningStateData, setWarningStateData] = useState<any>(
    //     [{
    //         label: "所有状态",
    //         value: "999"
    //     },
    //     {
    //         label: "正常",
    //         value: "success"
    //     },
    //     {
    //         label: "低",
    //         value: "error"
    //     },
    //     {
    //         label: "高",
    //         value: "warning"
    //     }]
    // );

    /** 差异状态 */
    const [differenceStateData, setDifferenceStateData] = useState<any>(
        [{
            label: "所有状态",
            value: "999"
        },
        {
            label: "大于等于0",
            value: "2"
        },
        {
            label: "小于等于0",
            value: "1"
        }]
    );

    const [warningData, setWarningData] = useState<any>();

    const [currentData, setCurrentData] = useState(1);
    const [pageSizeData, setPageSizeData] = useState(10);
    const [totalData, setTotalData] = useState(0);

    // const [warningStateIdData, setWarningStateIdData] = useState<any>();
    const [differenceStateIdData, setDifferenceStateIdData] = useState<any>();
    const [selectDateData, setSelectDateData] = useState<any>();

    const [loading, setLoading] = useState(false);

    /** api服务id */
    const apiId = 'ingredientWarning';

    // /** 后端数据wmService */
    // let wmService: any = systemConfig.wmService;

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {

        //同步获取数据 async - await
        const fetchData = async () => {

        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    const getFilters = () => {
        if (warningData) {
            // 1. 获取所有不重复的部门值
            let branchStoreMenuWarehouseSpecNames: any = [...new Set(warningData.map((item: { branchStoreMenuWarehouseSpecName: any; }) => item.branchStoreMenuWarehouseSpecName))];

            // 2. 转换为 filters 需要的格式
            return branchStoreMenuWarehouseSpecNames.map((branchStoreMenuWarehouseSpecName: any) => ({
                text: branchStoreMenuWarehouseSpecName,
                value: branchStoreMenuWarehouseSpecName,
            }));
        }
    };

    //表头
    const columnsHead = [
        {
            title: '门店',
            dataIndex: 'branchStoreName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.branchStore.brand.brandName + " " + record.branchStore.branchStoreName}</div>
                )
            }
        },
        {
            title: '菜式',
            dataIndex: 'foodName',
        },
        {
            title: '规格',
            dataIndex: 'branchStoreMenuWarehouseSpecName',
            filters: getFilters(),
            onFilter: (value: any, record: any) => record.branchStoreMenuWarehouseSpecName === value,
            filterSearch: true,
        },
        {
            title: '售价',
            dataIndex: 'sellPrice',
        },
        {
            title: '成本',
            dataIndex: 'costPrices',
        },
        {
            title: '标准毛利率',
            dataIndex: 'standardGrossProfitRatio',
            render: (text: any, record: any) => {
                return (
                    <div>{text + " %"}</div>
                )
            }
        },
        {
            title: '实时毛利率',
            dataIndex: 'grossProfitRatio',
            render: (text: any, record: any) => {
                return (
                    <div>{text + " %"}</div>
                )
            }
        },
        // {
        //     title: '预警范围',
        //     dataIndex: 'warningScope',
        // },
        {
            title: '记录时间',
            dataIndex: 'recordTime',
        },
        {
            title: '差异',
            dataIndex: 'difference',
            render: (text: any, record: any) => {
                if (text <= 0) {
                    return (
                        <div style={{ fontSize: 20, color: 'red' }}>
                            {text}
                        </div>
                    )
                }
                else {
                    return (
                        <div style={{ fontSize: 20, color: 'green' }}>
                            {text}
                        </div>
                    )
                }
            }
        },
        // {
        //     title: '预警状态',
        //     dataIndex: 'warningState',
        //     render: (text: any, record: any) => {
        //         switch (text) {
        //             case "error":
        //                 return (
        //                     <div style={{ fontSize: 20, color: 'red' }}>
        //                         {"低"}
        //                     </div>
        //                 )
        //             case "success":
        //                 return (
        //                     <div style={{ fontSize: 20, color: 'green' }}>
        //                         {"正常"}
        //                     </div>
        //                 )
        //             case "warning":
        //                 return (
        //                     <div style={{ fontSize: 20, color: 'yellow' }}>
        //                         {"高"}
        //                     </div>
        //                 )
        //             default:
        //                 return (
        //                     <div style={{ fontSize: 20, color: 'orange' }}>
        //                         {"暂没设置预警范围"}
        //                     </div>
        //                 )
        //         }
        //     }
        // },
    ];

    const dateChange = (_: any, dateStrings: any) => {
        setSelectDateData(dateStrings);
    };

    //查看不同预警状态的数据
    // const warningStateChange = (e: any) => {
    //     setWarningStateIdData(e);
    // }

    //查看不同差异状态的数据
    const differenceStateChange = (e: any) => {
        setDifferenceStateIdData(e);
    }

    const onFinish = () => {
        setLoading(true);
        form.validateFields()
            .then(async (values: any) => {
                if (!loading) {
                    fetchApi.GET(wmService, {
                        apiId,
                        apiExtend: "showPage",
                        apiData: {
                            ...values,
                            branchStoreId: contextData?.currentBranchStoreId,
                            mountDataOptions: {
                                userMount: {
                                    isDept: true
                                }
                            }
                        }
                    }).then(res => {
                        if (res.success) {
                            setWarningData(res.data.rows);
                            setCurrentData(res.data.current);
                            setPageSizeData(res.data.pageSize);
                            setTotalData(res.data.total);
                            setLoading(false);
                        }
                    }).catch(err => {
                        showCustomNotification(notificationApi!, {
                            type: 'error',
                            message: "错误，无法保存",
                            description: err.message + ' | status：' + err?.errors?.status,
                        });
                        setLoading(false);
                    })
                }
            })
            .catch((err: any) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
                setLoading(false);
            });
    }

    /**
     * 获取数据
     * @param options 选项
     * @returns 
     */
    const getPageData = async (options?: {
        /** 当前页 */
        current?: number,
        /** 分页数量 */
        pageSize?: number,
    }) => {
        if (typeof options === 'undefined') {
            options = {};
        }

        let { current, pageSize } = options;
        current = current ? current : currentData;
        pageSize = pageSize ? pageSize : pageSizeData;
        if (loadings === true) { return }
        loadings = true;
        fetchApi.GET(wmService, {
            apiId,
            apiExtend: 'showPage',
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId,
                differenceState: differenceStateIdData,
                // warningState: warningStateIdData,
                recordTime: selectDateData,
                current,
                pageSize,
                queryString: form.getFieldValue('queryString'),
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                }
            }
        }).then(res => {
            if (res.success === true) {
                setWarningData(res.data.rows);
                setCurrentData(res.data.current);
                setPageSizeData(res.data.pageSize);
                setTotalData(res.data.total);
            }
            loadings = false;
        })
    };

    // 表格分页属性
    const paginationProps = {
        showSizeChanger: true,
        showQuickJumper: false,
        showTotal: () => `共${totalData}条`,
        pageSize: pageSizeData,
        current: currentData,
        total: totalData,
        onShowSizeChange: (current: number, pageSize: number) =>
            getPageData({ current, pageSize }),
        onChange: (current: number) =>
            getPageData({ current }),
    };

    return (
        <>
            <div>
                <Form
                    form={form}
                    onFinish={onFinish}
                    initialValues={{ recordTime: [dayjs(), dayjs()] }}
                >
                    <Row>
                        {/* <Col span={3}>
                            <Form.Item
                                name="warningState"
                                label="预警状态"
                            >
                                <Select
                                    showSearch
                                    defaultValue="所有状态"
                                    onChange={warningStateChange}
                                    placeholder="预警状态"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    options={warningStateData}
                                >
                                </Select>
                            </Form.Item>
                        </Col> */}

                        <Col span={3}>
                            <Form.Item
                                name="differenceState"
                                label="差异状态"
                            >
                                <Select
                                    showSearch
                                    defaultValue="所有状态"
                                    onChange={differenceStateChange}
                                    placeholder="差异状态"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    options={differenceStateData}
                                >
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="时间"
                                name="recordTime"
                            >
                                <RangePicker
                                    format="YYYY-MM-DD"
                                    onChange={dateChange}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                name="queryString"
                            >
                                <Input placeholder='输入搜索内容' />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item >
                                <Button type="primary" htmlType="submit" disabled={loading}>
                                    搜索
                                </Button >
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>

            <Table
                size='small'
                columns={columnsHead}
                dataSource={warningData}
                pagination={paginationProps}
                loading={{
                    spinning: loading,
                    tip: '正在统计数据，请稍后...' // 自定义提示文字
                }}
            />
        </>
    )
}